
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trends/[[...slug]]",
      function () {
        return require("private-next-pages/trends/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trends/[[...slug]]"])
      });
    }
  